/**
 * Per-field bounds of `issueReportDiagnosticsSchema`, exported so the browser that assembles the
 * snapshot truncates against the same numbers the wire contract enforces.
 */
export const ISSUE_REPORT_DIAGNOSTICS_LIMITS = {
  route: 512,
  url: 2048,
  userAgent: 512,
  language: 16,
  role: 64,
  roles: 10,
  branch: 128,
  userEmail: 254,
  appVersion: 64,
  envType: 16,
  occurredAt: 64,
  affectedRecordLabel: 200,
  errorName: 128,
  errorMessage: 1024,
  stack: 8000,
} as const;
